import React from "react";
import team1 from "../../assets/gele15.png";

import TeamCarousel from "../../Components/Carousel/TeamCarousel";
import { BsTwitter, BsInstagram } from "react-icons/bs";
function TeamSection(props) {
  return (
    <div className="flex flex-col md:flex-row w-full px-10">
      <div className="flex-none px-10">
        <div className="flex md:w-2/3">
          <div className="w-full ">
            <h1 className="text-white pb-5 font-bold text-lg md:text-[35px]">
              {props.name}
            </h1>
          </div>
          <div className="flex justify-around w-2/3">
            <BsTwitter size={25} />
            <BsInstagram size={25} />
          </div>
        </div>
        <div className="bg-gradient-to-r from-violet-500 to-fuchsia-500 w-[280px] lg:w-[350px] h-[350px]">
          {" "}
          <img src={team1} alt="" />
        </div>
      </div>
      <div className="z-20 shadow-xl w-8 h-8 "></div>
      <div className="w-full md:grow md:w-7/12 px-10 overflow-hidden pb-10 flex flex-col justify-center">
        <h1 className="text-white pb-5 font-bold text-lg md:text-[40px]">
          NFT Artwork
        </h1>
        <TeamCarousel />
      </div>
    </div>
  );
}

export default TeamSection;
